module.exports = __webpack_public_path__ + "img/image_tripplaner.85c050d2.png";